module.exports = __webpack_public_path__ + "static/media/warning_sign.23a93e27.png";